export interface Credentials {
    // Customize received credentials here
    username: string;
    token: string;
}
